import {
  TRESPONSE_DAILY_OPL_CAPACITIES,
  TRESPONSE_HL_BOARD_LISTING,
  TRESPONSE_OTL_CAPACITIES_INFO,
  TRESPONSE_WEEKLY_OPL_CAPACITIES,
} from '@monorepo/types';

export type THLBoardState = {
  hlBoardList: TRESPONSE_HL_BOARD_LISTING | null;
  OTLCapacitiesInfo: TRESPONSE_OTL_CAPACITIES_INFO | null;
  WeeklyOPLCapacitiesInfo: TRESPONSE_WEEKLY_OPL_CAPACITIES | null;
  DailyOTLCapacitiesInfo: TRESPONSE_DAILY_OPL_CAPACITIES | null;
};

export const THLBoardInfoActionType = {
  GetHLBoardList: 'GET_HL_BOARD_LIST' as const,
  GetHLBoardListSuccess: 'GET_HL_BOARD_LIST_SUCCESS' as const,
  GetHLBoardListFailure: 'GET_HL_BOARD_LIST_FAILURE' as const,
  GetOTLCapacitiesInfo: 'GET_OTL_CAPACITIES_INFO' as const,
  GetOTLCapacitiesInfoSuccess: 'GET_OTL_CAPACITIES_INFO_SUCCESS' as const,
  GetOTLCapacitiesInfoFailure: 'GET_OTL_CAPACITIES_INFO_FAILURE' as const,
  GetWeeklyOPLCapacitiesInfo: 'GET_WEEKLY_OPL_CAPACITIES_INFO' as const,
  GetWeeklyOPLCapacitiesInfoSuccess: 'GET_WEEKLY_OPL_CAPACITIES_INFO_SUCCESS' as const,
  GetWeeklyOPLCapacitiesInfoFailure: 'GET_WEEKLY_OPL_CAPACITIES_INFO_FAILURE' as const,
  GetDailyOPLCapacitiesInfo: 'GET_DAILY_OPL_CAPACITIES_INFO' as const,
  GetDailyOPLCapacitiesInfoSuccess: 'GET_DAILY_OPL_CAPACITIES_INFO_SUCCESS' as const,
  GetDailyOPLCapacitiesInfoFailure: 'GET_DAILY_OPL_CAPACITIES_INFO_FAILURE' as const,
};
